import { IBarcodeValueItemBean } from "../../../infrastructure/document/ver2/beans/items";

export class BarcodeValueItem {
  // フロント側では使用しないのでそのままの値を保持する
  constructor(public origin: IBarcodeValueItemBean) {}
}
